import React from "react";
import numeral from "numeral";
const GaugeDetails = ({ metric: { metric: gauge } }) => /* @__PURE__ */ React.createElement("dl", { className: "metric-def metric-gauge" }, /* @__PURE__ */ React.createElement("dt", null, "Value:"), /* @__PURE__ */ React.createElement("dd", null, /* @__PURE__ */ React.createElement("span", { className: "number-format" }, numeral(gauge.value).format("0,0"))));
export default GaugeDetails;
